import { all, call, debounce, fork, put, takeLeading } from "typed-redux-saga";
import { Action, configureProductActions } from "./configure-product-store";
import { errorActions } from "src/components/error-viewer/error-store";
import { ConfiguratorService } from "src/backend/openapi/v1";
import { getContactPerson, getCurrentCustomer } from "src/utils";
import { applicationActions } from "src/components/application-store";

export function* getConfiguration(action: ReturnType<typeof configureProductActions.getConfigurationRequest>) {
  try {
    const contactPerson = yield* getContactPerson();
    const customer = yield* getCurrentCustomer();
    if (!contactPerson.identityId) throw Error("Missing identity id");

    const result = yield* call(ConfiguratorService.getApiV1ConfiguratorConfiguration, action.payload.configurationId, contactPerson.identityId, customer.customerId);
    yield put(configureProductActions.getConfigurationSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(configureProductActions.getConfigurationFail());
  }
}

export function* watchGetConfiguration() {
  yield takeLeading(Action.GetConfigurationRequest, getConfiguration);
}

export function* updateProjectLineItem(action: ReturnType<typeof configureProductActions.updateProjectLineItemRequest>) {
  try {
    const contactPerson = yield* getContactPerson();
    const customer = yield* getCurrentCustomer();
    if (!contactPerson.identityId) throw Error("Missing identity id");

    yield put(applicationActions.setGlobalLoadingBar(true));
    const result = yield* call(
      ConfiguratorService.putApiV1ConfiguratorProjectLineItems,
      action.payload.data.projectLineItemId,
      contactPerson.identityId,
      customer.customerId,
      undefined,
      action.payload.data
    );
    yield put(configureProductActions.updateProjectLineItem(result));
  } catch (error) {
    yield put(errorActions.addError(error));
  } finally {
    yield put(applicationActions.setGlobalLoadingBar(false));
  }
}

export function* watchUpdateProjectLineItem() {
  yield takeLeading(Action.UpdateProjectLineItemRequest, updateProjectLineItem);
}

export function* updateProjectLineItemAttribute(action: ReturnType<typeof configureProductActions.updateProjectLineItemAttributeRequest>) {
  try {
    const contactPerson = yield* getContactPerson();
    const customer = yield* getCurrentCustomer();
    if (!contactPerson.identityId) throw Error("Missing identity id");

    yield put(applicationActions.setGlobalLoadingBar(true));
    const result = yield* call(
      ConfiguratorService.putApiV1ConfiguratorProjectLineItemsAttributes,
      action.payload.data.projectLineItemId,
      contactPerson.identityId,
      customer.customerId,
      undefined,
      action.payload.data
    );
    yield put(configureProductActions.updateProjectLineItemAttributes(result.projectLineItemId, result.attributes));
  } catch (error) {
    yield put(errorActions.addError(error));
  } finally {
    yield put(applicationActions.setGlobalLoadingBar(false));
  }
}

export function* watchUpdateProjectLineItemAttribute() {
  yield debounce(500, Action.UpdateProjectLineItemAttributeRequest, updateProjectLineItemAttribute);
}

export function* generateConfigurationOrder(action: ReturnType<typeof configureProductActions.getGenerateConfigurationOrderRequest>) {
  try {
    const contactPerson = yield* getContactPerson();
    const customer = yield* getCurrentCustomer();
    if (!contactPerson.identityId) throw Error("Missing identity id");

    const result = yield* call(
      ConfiguratorService.getApiV1ConfiguratorGenerateConfigurationOrder,
      action.payload.projectId,
      action.payload.configurationId,
      contactPerson.identityId,
      customer.customerId
    );
    yield put(configureProductActions.getGenerateConfigurationOrderSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchgenerateConfigurationOrder() {
  yield debounce(1000, Action.GetGenerateConfigurationOrderRequest, generateConfigurationOrder);
}

export function* configureProductSaga() {
  yield all([fork(watchGetConfiguration), fork(watchUpdateProjectLineItemAttribute), fork(watchUpdateProjectLineItem), fork(watchgenerateConfigurationOrder)]);
}
